<script setup lang="ts">
import CircleStopIcon from '@/assets/icons/shared/circle/stop.svg';
import CircleCheckIcon from '@/assets/icons/shared/circle/check.svg';
import CircleErrorIcon from '@/assets/icons/shared/circle/error.svg';
import type { SubmitTaskState } from '@/modules/document/document-master/types/submit-task.ts';
import type { I18TParams } from '@/i18n.ts';
import UiSpinner from '@/modules/ui/components/ui/UiSpinner.vue';

defineProps<{
  items: {
    code: string;
    title: string | I18TParams;
    state: SubmitTaskState;
  }[];
}>();
</script>

<template>
  <ul class="wizard-submit-step">
    <li
      v-for="{ code, title, state } in items"
      :key="code"
      class="item"
    >
      <UiSpinner v-if="state === 'loading'" />
      <CircleStopIcon v-else-if="state === 'stopped'" />
      <CircleCheckIcon
        v-else-if="state === 'success'"
        class="icon _green"
      />
      <CircleErrorIcon
        v-else-if="state === 'error'"
        class="icon _red"
      />

      <span v-postfix>
        {{ typeof title === 'string' ? $t(title) : $t(title.key, title.params) }}
      </span>
    </li>
  </ul>
</template>

<style scoped lang="scss">
.wizard-submit-step {
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 0;
}

.item {
  display: flex;
  min-width: 0;
  align-items: center;
  font-size: var(--font-size-l);
  line-height: var(--line-height-l);
}

.icon {
  width: 20px;
  height: 20px;

  &._green {
    fill: var(--color-green-800);
  }

  &._red {
    fill: var(--color-red-900);
  }
}
</style>
